<template>
  <div class="hyperlink-container">
    <b-button
      icon-left="link-variant"
      variant="primary"
      @click="openSelectHyperlink"
      >{{ $t('create_external_link') }}</b-button
    >

    <DocumentsModal
      v-if="isDocumentModalVisible"
      :isDocumentModalVisible="isDocumentModalVisible"
      @close="closeDocumentModal"
      :selectMode="true"
      :singleSelectMode="singleSelectMode"
      @onSelectMultipleFiles="onSelectMultipleFiles"
      :preSelectedFiles="instruction?.linkedInternalDocuments || []"
    />
  </div>
</template>
<script>
import DocumentsModal from '../DocumentsModal';

export default {
  name: 'HyperlinkButton',
  components: {
    DocumentsModal,
  },

  props: {
    instruction: {
      type: Object,
      required: true,
    },
    singleSelectMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDocumentModalVisible: false,
    };
  },

  methods: {
    openSelectHyperlink() {
      this.isDocumentModalVisible = true;
    },
    closeDocumentModal() {
      this.isDocumentModalVisible = false;
    },
    onSelectMultipleFiles(files) {
      this.closeDocumentModal();
      const fileIds = files.map((entry) => entry._id);
      if (this.singleSelectMode) {
        this.$emit('singleFileName', files[0].name);
      }
      this.$emit('onLinkedInternalDocuments', fileIds);
    },
  },
};
</script>
<style scoped>
.hyperlink-container {
  margin-top: 10px;
}
</style>
